import {css} from 'glamor'
import PropTypes from 'prop-types'
import {default as React, useEffect} from 'react'
import Modal from 'react-bootstrap/lib/Modal'
import {connect} from 'react-redux'
import {subscribe} from '../../redux/actions/newsletter'
import {media} from '../../styles'
import {useLocalStorage} from '../hooks/useLocalStorage'
import ModalContent from './modalContent'

const style = {
  modal: css({
    display: 'flex !important',
    alignItems: 'center',
    ...media.xs({
      alignItems: 'flex-end',

      '& .email-modal-dialog': {
        width: '100%'
      }
    })
  })
}

const EmailModal = ({subscribeEmail}) => {
  const [shouldShowSignupPrompt, setShouldShowSignupPrompt] = useLocalStorage(
    'showSignupPrompt',
    true
  )

  const [showModal, setShowModal] = React.useState(false)

  useEffect(() => {
    if (shouldShowSignupPrompt) {
      const timeout = setTimeout(() => {
        setShowModal(true)
      }, 10000)

      return () => clearTimeout(timeout)
    }
  }, [shouldShowSignupPrompt])

  const hideModalCallback = React.useCallback(() => {
    setShouldShowSignupPrompt(false)
    setShowModal(false)
  }, [])

  return (
    <Modal
      show={showModal}
      onHide={hideModalCallback}
      {...style.modal}
      dialogClassName="email-modal-dialog">
      <ModalContent
        hideModalCallback={hideModalCallback}
        subscribeEmail={subscribeEmail}
      />
    </Modal>
  )
}

EmailModal.propTypes = {
  subscribeEmail: PropTypes.func.isRequired
}

EmailModal.displayName = 'EmailModal'
EmailModal.staticEntry = 'emailPopup'

const dispatchToProps = dispatch => ({
  subscribeEmail: email => dispatch(subscribe({email}))
})
export default connect(() => ({}), dispatchToProps)(EmailModal)
